import React, { useEffect, useState } from "react";
import { search_icon } from "../../../assets/imgs";
import { useLocation } from "react-router-dom";
import SelectBox from "../../../components/SelectBox";
import { violations } from "../../redux/api/dummyJson";
import StatusComp from "../../../components/StatusComp";
import { Table } from "../../../components/Table/Table";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";

const SiteCamera = () => {
  const [pagination, setPagination] = useState("");
  const user_details = JSON.parse(localStorage.getItem("user_details"));

  const violationTypeList = [
    { name: "No_Helmet", id: 1 },
    { name: "No_Shoes", id: 2 },
    { name: "No_Harness", id: 3 },
  ];

  const [cameraList, setCameraList] = useState([]);
  const [violationType, setViolationType] = useState([]);
  const [searchText, setSearchText] = useState("");

  // const cameraList = [
  //   { name: "KNF C001", id: 1 },
  //   { name: "KNF C002", id: 2 },
  //   { name: "KNF C003", id: 3 },
  //   { name: "KNF C004", id: 4 },
  //   { name: "KNF C005", id: 5 },
  //   { name: "KNF C006", id: 6 },
  //   { name: "KNF C007", id: 7 },
  //   { name: "KNF C008", id: 8 },
  //   { name: "KNF C009", id: 9 },
  //   { name: "KNF C010", id: 10 },
  // ];
  const [page, setPage] = useState(1);

  const [data, setData] = useState([]);

  const [types, setTypes] = useState([]);
  const [camTypes, setCamTypes] = useState([]);
  const [selectedType, setSelecetedType] = useState(null);
  const [selecetdCam, setSelectedCam] = useState(null);

  const location = useLocation();

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },
      {
        Header: "Camera Number",
        accessor: "camera_code",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Camera Name",
        accessor: "camera_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Violation Type",
        accessor: "alert_type_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Severity",
        accessor: "alert_type_severity",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
    ],
    []
  );

  const getCameraList = () => {
    let formdata = new FormData();
    formdata.append("site_id", user_details?.knf_company_site_id);
    // formdata.append("site_id", 2);
    post(URL.CAMERA_LISTS, formdata)
      .then((res) => {
        if (res?.cameras?.length > 0) {
          let temp = [];
          res?.cameras?.map((item, ind) => {
            let obj_ = {
              ...item,
              name_old: item?.name,
              name: `${item?.code} - ${item?.name}`,
            };
            temp.push(obj_);
          });
          setCameraList(temp);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getTypesList = () => {
    let formdata = new FormData();
    formdata.append("site_id", user_details?.knf_company_site_id);
    // formdata.append("site_id", 2);
    get(URL.ALERT_TYPES_ALL)
      .then((res) => {
        if (res?.alert_types?.length > 0) {
          setViolationType(res?.alert_types);
        } else {
          setViolationType([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getList = (camera_id, alert_id, search_) => {
    // console.log("search", search_);
    let formdata = new FormData();
    formdata.append("site_id", user_details?.knf_company_site_id);
    setSelectedCam(camera_id);
    setSelecetedType(alert_id);
    if (camera_id?.value) {
      formdata.append("camera_id", camera_id?.value);
    }
    if (alert_id?.value) {
      formdata.append("alert_id", alert_id?.value);
    }
    if (search_) {
      formdata.append("search", search_);
    }
    setSearchText(search_);
    post(URL.CAMERA_ALERT_LISTS, formdata)
      .then((res) => {
        if (res?.status == "success") {
          setData(res?.data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getCameraList();
    getTypesList();
    getList();
  }, []);

  return (
    <div className="dashRightView ">
      <StatusComp name={"Site Cameras"} />

      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{data?.length}
        </h2>

        <div className="col-md-3 ">
          <label className="form-label">Select Camera</label>
          <SelectBox
            arrayData={cameraList}
            data={camTypes}
            setData={setCamTypes}
            selectedOption={selecetdCam}
            setSelectedOption={(event) => getList(event, selectedType)}
            style={true}
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Select Type</label>
          <SelectBox
            arrayData={violationType}
            data={types}
            setData={setTypes}
            selectedOption={selectedType}
            setSelectedOption={(event) => getList(selecetdCam, event)}
            style={true}
          />
        </div>
        <div className="d-flex gap-3">
          <div className="search-input mt-4">
            <input
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
              onChange={(e) =>
                getList(selecetdCam, selectedType, e.target.value)
              }
              value={searchText}
            />
            <img src={search_icon} className="search" />
          </div>
        </div>
      </div>

      <Table
        columns={columns}
        pageno={page}
        setPageno={setPage}
        pagecount={pagination}
        data={data}
        show={true}
      />
    </div>
  );
};

export default SiteCamera;
